export class BaiduStyleMap {

  public style = [{
    featureType: 'land',
    elementType: 'geometry.fill',
    stylers: {
      color: '#F4F4F2',
      visibility: 'on',
    },
  },
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: {
        color: '#CAD2D3',
        visibility: 'on',
      },
    },
    {
      featureType: 'green',
      elementType: 'geometry.fill',
      stylers: {
        color: '#d7d7d7',
        visibility: 'on',
      },
    },
    {
      featureType: 'building',
      elementType: 'geometry.fill',
      stylers: {
        color: '#a7a7a7ff',
        visibility: 'on',
      },
    },
    {
      featureType: 'highway',
      elementType: 'geometry.fill',
      stylers: {
        color: '#ffffff',
        visibility: 'on',
      },
    },
    {
      featureType: 'subway',
      elementType: 'geometry.fill',
      stylers: {
        color: '#ffffff',
        visibility: 'on',
      },
    },
    {
      featureType: 'highway',
      elementType: 'labels.text.fill',
      stylers: {
        color: '#b3b3b3',
        visibility: 'on',
      },
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: {
        color: '#b3b3b3ff',
        visibility: 'on',
      },
    },
    {
      featureType: 'arterial',
      elementType: 'geometry.fill',
      stylers: {
        color: '#ffffff',
        visibility: 'on',
      },
    },
    {
      featureType: 'road',
      elementType: 'labels',
      stylers: {
        color: '#696969',
        weight: '0.1',
        visibility: 'off',
      },
    },
    {
      featureType: 'building',
      elementType: 'geometry.fill',
      stylers: {
        color: '#a7a7a7',
        weight: '0.1',
        visibility: 'on',
      },
    },
    {
      featureType: 'building',
      elementType: 'geometry.fill',
      stylers: {
        color: '#eeeeeeff',
        weight: '0.1',
        visibility: 'on',
      },
    },
  ];

}

